<template>
  <div class="home-container">
    <div class="header-section">
      <div class="title-wrapper">
        <div class="title-decoration"></div>
        <h1>Destacadas</h1>
      </div>
      <div class="current-date">{{ formattedDate }}</div>
    </div>
    <SliderPrincipal />
    <div class="header-section">
      <div class="title-wrapper">
        <div class="title-decoration"></div>
        <h1>Última Hora</h1>
      </div>
    </div>
    <SliderHome />
    <div class="header-section">
      <div class="title-wrapper">
        <div class="title-decoration"></div>
        <h1>Actualidad</h1>
      </div>
    </div>
    <ActualidadList />
    <div class="header-section">
      <div class="title-wrapper">
        <div class="title-decoration"></div>
        <h1>Deportes</h1>
      </div>
    </div>
    <DeportesList />
    <div class="header-section">
      <div class="title-wrapper">
        <div class="title-decoration"></div>
        <h1>Sslud</h1>
      </div>
    </div>
    <SaludList />
    <div class="header-section">
      <div class="title-wrapper">
        <div class="title-decoration"></div>
        <h1>Ciencia y Tecnología</h1>
      </div>
    </div>
    <CienciaTecnologia />
    
    <!-- Aquí va el resto de tu contenido -->
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import SliderPrincipal from '.././../components/SliderPrincipalHome.vue'
import SliderHome from '.././../components/SliderHome.vue'
import ActualidadList from '.././../components/ActualidadList.vue'
import DeportesList from '.././../components/DeportesList.vue'
import SaludList from '.././../components/SaludList.vue'
import CienciaTecnologia from '.././../components/CienciaTecnologia.vue'

const route = useRoute()
const formattedDate = ref('')

const formatCurrentDate = () => {
  const date = new Date()
  const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
  
  const dayName = days[date.getDay()]
  const day = date.getDate()
  const month = months[date.getMonth()]
  const year = date.getFullYear()
  
  formattedDate.value = `${dayName} ${day} de ${month} de ${year}`
}

const loadData = () => {
  formatCurrentDate()
}

onMounted(() => {
  loadData()
})

watch(() => route.fullPath, () => {
  loadData()
})
</script>

<style scoped>
.home-container {
  padding: 20px;
  margin-top: 80px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 10px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-decoration {
  width: 4px;
  height: 24px;
  background: #a50000;
  border-radius: 2px;
}

.header-section h1 {
  font-size: 20px;
  font-weight: bold;
  color: #001b4a;
  margin: 0;
}

.current-date {
  font-size: 14px;
  color: #666;
  font-weight: normal;
}

/* Responsive */
@media (max-width: 480px) {
  .home-container {
    padding: 15px;
  }
  
  .header-section h1 {
    font-size: 18px;
  }
  
  .title-decoration {
    height: 20px;
  }
  
  .current-date {
    font-size: 12px;
  }
}
</style>